import {isNil} from 'ramda';

import {RichTextTemplateTokens} from '../types';
import {TEMPLATE_TOKEN} from './TEMPLATE_TOKEN';
import {TemplateTokenValue} from './TemplateTokenBlot';

export type TemplateTokenTextPart =
  | {type: 'text'; text: string; index: number}
  | ({type: 'token'; index: number; length: number} & TemplateTokenValue);

/**
 * Splits plain text into literal text and known placeholders. An unknown code stays text; text is
 * never matched against labels.
 */
export function splitTemplateTokenText(text: string, getLabel: RichTextTemplateTokens['getLabel']) {
  const parts: TemplateTokenTextPart[] = [];
  let cursor = 0;

  for (const match of text.matchAll(TEMPLATE_TOKEN.placeholderPattern)) {
    const code = match.groups?.code;
    const label = isNil(code) ? null : getLabel(code);

    if (isNil(code) || isNil(label) || label === '') {
      continue;
    }

    if (match.index > cursor) {
      parts.push({type: 'text', text: text.slice(cursor, match.index), index: cursor});
    }
    parts.push({type: 'token', code, label, index: match.index, length: match[0].length});
    cursor = match.index + match[0].length;
  }

  if (cursor < text.length) {
    parts.push({type: 'text', text: text.slice(cursor), index: cursor});
  }

  return parts;
}
